import SupplierTable from '@/supplierForecastModule/pages/main.vue';
export default SupplierTable;
